import {selectNavOption} from "../helpers/nav_option_helpers";
import {selectExperienceMarker} from "../helpers/experience_marker_helpers";
import {clearExperienceMarker, clearNavOption, setNavOpen, setRenderMapBounds} from "../helpers/commit_helpers";

export default function filterExperienceRouteRequested(sm, payload) {
    const experience = payload.experience;
    const mapFilter = payload.mapFilter;

    const navOption = mapFilter?.onlineAppNavOption;
    const experienceMarker = experience?.experienceMarker;

    if (navOption) {
        // The navOption may have map bounds (triggering a map pan/zoom).
        // When a filter experience route is requested we don't wish for this to happen.
        // So we temporarily true off the rendering of map bounds.
        setRenderMapBounds(sm, false);
        selectNavOption(sm, navOption);
        setRenderMapBounds(sm, true);
        navOption.fireSelectedWithRouteRequestEvent(); // Event to be picked up by Nav's PaneOptionComponent event listener.
    } else {
        if(isCurrentNavOption(sm)) clearNavOption(sm);
    }

    if (experienceMarker) {
        selectExperienceMarker(sm, mapFilter, experienceMarker);
        setNavOpen(sm, false);
    } else {
        if(isCurrentExperienceMarker(sm)) clearExperienceMarker(sm);
    }


}

// Private…

function isCurrentExperienceMarker(sm) {
    return !!sm.state['experienceMarker'];
}

function isCurrentNavOption(sm) {
    return !!sm.state['navOption'];
}